const DEFAULT_OPTIONS = {
  gravity: "top", // top / bottom
  position: "right", // left / center / right
  duration: 3000,
  close: true,
  style: {
    color: "#fff",
    fontWeight: "500",
  },
};

// Common function with title
export const showToast = (message, title, type = "info", options = {}) => {
  let bgColor;

  switch (type) {
    case "success":
      bgColor = "rgb(var(--success),1)";
      break;
    case "error":
      bgColor = "rgb(var(--danger),1)";
      break;
    case "warning":
      bgColor = "rgb(var(--warning),1)";
      break;
    case "info":
    default:
      bgColor = "rgb(var(--info),1)";
      break;
  }

  // Combine title and message using HTML
  const htmlContent = `
    <strong style="display:block;margin-bottom:4px;">${title}</strong>
    <span>${message}</span>
  `;

  Toastify({
    text: htmlContent,
    escapeMarkup: false, // allow HTML
    ...DEFAULT_OPTIONS,
    ...options,
    style: {
      ...DEFAULT_OPTIONS.style,
      background: bgColor,
      ...(options.style || {}),
    },
  }).showToast();
};

// Convenience functions
export const ErrorToast = (msg, title = "Error", options) =>
  showToast(msg, title, "error", options);
export const SuccessToast = (msg, title = "Success", options) =>
  showToast(msg, title, "success", options);
export const WarningToast = (msg, title = "Warning", options) =>
  showToast(msg, title, "warning", options);
export const InfoToast = (msg, title = "Info", options) =>
  showToast(msg, title, "info", options);
